import React from "react";
import { Field } from "react-final-form";
import Form from "react-bootstrap/Form";
import UiTopInputElementsWr from "../../_uiComponents/common/UiTopInputElementsWr";
import PropTypes from "prop-types";

export default function UiTopInput(props) {
    return (
        <Field
            name={props.name}
            render={({ input, meta }) => {
                return (
                    <>
                        <UiTopInputElementsWr>
                            <label htmlFor={props.label}>{props.label}</label>
                            <Form.Group>
                                <Form.Control
                                    {...input}
                                    {...props}
                                    type="text"
                                    placeholder={props.placeholder}
                                    value={props.value}
                                    id={props.label}
                                    isInvalid={
                                        meta.invalid &&
                                        meta.touched &&
                                        !meta.active
                                    }
                                />

                                <Form.Control.Feedback type="invalid">
                                    {meta.error}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </UiTopInputElementsWr>
                    </>
                );
            }}
        />
    );
}

UiTopInput.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    errorType: PropTypes.string,
    errorMsg: PropTypes.string,
};
